"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.MIN_WIDTH_CATEGORIZED_SEARCH = void 0;
const common_1 = require("../../../common");
const styles_1 = require("../../../helpers/styles");
exports.MIN_WIDTH_CATEGORIZED_SEARCH = (0, styles_1.calcWidth)(common_1.CONTROL_SIZE.l);
//# sourceMappingURL=constants.js.map